module.exports = __webpack_public_path__ + "static/media/profile_robert.9fad9afd.JPG";